import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { FastlyImage } from '@components/common/image'

const BOARDS = [
  'Common Core (US)',
  'GCSE (UK)',
  'IB (International)',
  'ATAR (Australia)',
  'NCERT (India)',
  'CBSE (India)',
  'ICSE (India)',
  'O-Level (PK, BD, Africa)',
  'IGCSE (International)',
  '+ 125 more',
]

type Props = {
  urlQuery?: string
}

const EveryClassCurriculum = ({ urlQuery }: Props) => {
  return (
    <section className="bg-white py-12 lg:py-16 px-5">
      <div className="container mx-auto text-center">
        <h2 className="text-2xl lg:text-4xl font-600 leading-tight mb-4 text-grey max-w-4xl mx-auto">
          Every class follows your child&apos;s exact school curriculum
        </h2>
        <p className="text-base lg:text-lg text-grey mx-auto mb-10 max-w-4xl">
          No two school curricula are the same. Generic online tutoring picks
          one and hopes it fits. We start with your child&apos;s board and build
          from there.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-4 max-w-4xl mx-auto mb-8">
          {BOARDS.map((board) => (
            <div
              key={board}
              className="border border-blue-100 bg-blue-50 bg-opacity-50 rounded-lg py-3 px-4 text-blue-200 font-600 text-base lg:text-lg"
            >
              {board}
            </div>
          ))}
        </div>

        <div className="bg-orange-100 bg-opacity-40 border border-orange-200 rounded-xl p-4 lg:p-5 flex flex-col sm:flex-row items-center gap-2 sm:gap-4 max-w-4xl mx-auto">
          <FastlyImage
            src="/images/courses/math/icons/cody-with-pencil-circular.png"
            alt="Cody"
            width={60}
            height={60}
            className="flex-shrink-0"
          />
          <p className="lg:text-lg text-orange leading-snug text-center sm:text-left">
            Every class starts from where your child actually is. Share their
            syllabus or exam schedule and we build a learning plan around it,
            skipping what they already know and focusing on what will move them
            forward.
          </p>
        </div>

        <div className="flex justify-center mt-8">
          <BookFreeClassBtn query={urlQuery} />
        </div>
      </div>
    </section>
  )
}

export default EveryClassCurriculum
